import React, { useCallback, useEffect, useState, useRef } from 'react';
import {
  DateField,
  ListContextProvider,
  NumberField,
  ReferenceField,
  TextField,
  useGetList,
  useListContext,
  ListBase,
  ListToolbar,
  Pagination,
  ShowButton,
  Datagrid,
} from 'react-admin';

import { Divider, Tabs, Tab, Card } from '@material-ui/core';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';

import DialogoDeleteResource from './DialogoDeletar';
import ActionsList from '../../Components/ReactAdmin/ActionsList';
import { ProtegerPagina } from '../../layout/VerificaPermissaoPage';
import Dialogo from './ContainerDialogoDevolucao';
import Filter from './Filter';
import {} from '../../utils/dadosTelas';
import ActionsField from '../../Components/ReactAdmin/Fields/ActionsField';

const tabs = [
  { id: 'confirmado', name: 'confirmado' },
  { id: 'cancelado', name: 'cancelado' },
];

// A aba ativa já tem sua contagem de graça no total da própria lista, então só
// a aba inativa custa requisição. `filtroFixo` é o filtro permanente da tela
// (devolucao), que o react-admin mescla apenas na query principal e não vem
// junto de filterValues.
const useGetTotalAbaInativa = (filterValues, filtroFixo, cancelado) => {
  const { total } = useGetList(
    'vendas',
    { perPage: 1, page: 1 },
    { field: 'id', order: 'ASC' },
    { ...filterValues, ...filtroFixo, cancelado },
  );

  return total;
};

const MyList = ({ ...props }) => {
  const refDialogoCompra = useRef(null);
  const listContext = useListContext();
  const {
    ids,
    filterValues,
    setFilters,
    displayedFilters,
    total: totalAbaAtiva,
  } = listContext;
  const [confirmados, setConfirmados] = useState([]);
  const [cancelados, setCancelados] = useState([]);
  const abaCancelada = filterValues.cancelado === true;
  const totalAbaInativa = useGetTotalAbaInativa(
    filterValues,
    props.filter,
    !abaCancelada,
  );
  const totals = {
    confirmado: abaCancelada ? totalAbaInativa : totalAbaAtiva,
    cancelado: abaCancelada ? totalAbaAtiva : totalAbaInativa,
  };
  const refDialogoDeleteResource = useRef(null);

  useEffect(() => {
    if (ids && ids !== filterValues.cancelado) {
      switch (filterValues.cancelado) {
        case false:
          setConfirmados(ids);
          break;
        case true:
          setCancelados(ids);
          break;
        default:
          break;
      }
    }
  }, [ids, filterValues.cancelado]);

  const handleChange = useCallback(
    (event, value) => {
      if (setFilters) {
        setFilters(
          { ...filterValues, cancelado: value === 'cancelado' },
          displayedFilters,
        );
      }
    },
    [displayedFilters, filterValues, setFilters],
  );
  function handleCriar() {
    if (refDialogoCompra.current) {
      refDialogoCompra.current.handleCreate();
    }
  }
  function handleEdit({ id }) {
    if (refDialogoCompra.current) {
      refDialogoCompra.current.handleEdit(id);
    }
  }
  return (
    <>
      <ListToolbar
        filters={props.filters}
        actions={<ActionsList handleCriar={handleCriar} {...props} />}
        {...props}
      />
      <Card style={{ borderRadius: '20px' }} {...props}>
        <Tabs
          variant="fullWidth"
          centered
          value={filterValues.cancelado ? tabs[1].id : tabs[0].id}
          indicatorColor="primary"
          onChange={handleChange}
        >
          {tabs.map((choice) => (
            <Tab
              key={choice.id}
              label={
                totals[choice.name] === undefined
                  ? choice.name
                  : `${choice.name} (${totals[choice.name]})`
              }
              value={choice.id}
            />
          ))}
        </Tabs>
        <Divider />
        <div>
          {filterValues.cancelado === false && (
            <ListContextProvider value={{ ...listContext, ids: confirmados }}>
              <Datagrid {...props}>
                <TextField source="numero" label="Nº venda" />
                <ReferenceField
                  label="Cliente"
                  source="cliente_id"
                  reference="clientes"
                  linkType={false}
                >
                  <TextField source="nome" />
                </ReferenceField>
                <NumberField
                  source="valor"
                  locales="pt-BR"
                  options={{
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
                    style: 'currency',
                    currency: 'BRL',
                  }}
                  label="Valor Total"
                />
                <DateField source="data" label="Data da Venda" />
                <ShowButton />
                <ActionsField
                  source="lalala"
                  textAlign="right"
                  label="Ações"
                  sortable={false}
                  /* handleEdit={handleEdit}
            handleShow={handleShow} */
                  actions={[
                    {
                      key: 'editar',
                      title: 'Editar',
                      icon: <EditOutlinedIcon />,
                      onClick: (rec) => handleEdit(rec),
                      show: () => true,
                      disabled: () => false,
                    },
                  ]}
                />
              </Datagrid>
            </ListContextProvider>
          )}
          {filterValues.cancelado === true && (
            <ListContextProvider value={{ ...listContext, ids: cancelados }}>
              <Datagrid {...props}>
                <TextField source="numero" label="Nº venda" />
                <ReferenceField
                  label="Cliente"
                  source="cliente_id"
                  reference="clientes"
                  linkType={false}
                >
                  <TextField source="nome" />
                </ReferenceField>
                <NumberField
                  source="valor"
                  locales="pt-BR"
                  options={{
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
                    style: 'currency',
                    currency: 'BRL',
                  }}
                  label="Valor Total"
                />
                <DateField source="data" label="Data da Venda" />
                <ShowButton />
                <ActionsField
                  source="lalala"
                  textAlign="right"
                  label="Ações"
                  sortable={false}
                  /* handleEdit={handleEdit}
            handleShow={handleShow} */
                  actions={[
                    {
                      key: 'editar',
                      title: 'Editar',
                      icon: <EditOutlinedIcon />,
                      onClick: (rec) => handleEdit(rec),
                      show: () => true,
                      disabled: () => false,
                    },
                  ]}
                />
              </Datagrid>
            </ListContextProvider>
          )}
        </div>
        <TransacoesPagination />
      </Card>
      <Dialogo ref={refDialogoCompra} />
      <DialogoDeleteResource ref={refDialogoDeleteResource} />
    </>
  );
};

const ContainerMyList = ({ children, ...props }) => (
  <>
    <ListBase {...props}>
      <MyList {...props} />
    </ListBase>
  </>
);

const TransacoesPagination = (props) => (
  <Pagination rowsPerPageOptions={[5, 10, 25, 50, 100, 150, 200]} {...props} />
);

const List2 = (props) => (
  <ProtegerPagina permissao="publico">
    <ContainerMyList
      {...props}
      bulkActionButtons={false}
      pagination={<TransacoesPagination />}
      perPage={50}
      filters={<Filter />}
      title="Compras"
      filterDefaultValues={{
        periodo: {
          start: new Date(),
          end: new Date(),
        },
        cancelado: false,
      }}
      filter={{ devolucao: true }}
    />
  </ProtegerPagina>
);

export default List2;
